export const footerMapper = {
    navLinks: [
        { id: 'home', label: 'Home' },
        { id: 'empresa', label: 'Empresa' },
        { id: 'solucoes', label: 'Serviços' },
        { id: 'contato', label: 'Contato' },
    ],
    socialLinks: {
        facebook: process.env.REACT_APP_FACEBOOK_URL,
        instagram: process.env.REACT_APP_INSTAGRAM_URL,
        linkedin: process.env.REACT_APP_LINKEDIN_URL,
        email: `mailto:${process.env.REACT_APP_EMAIL}`,
        whatsapp: `https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}?text=${encodeURIComponent(process.env.REACT_APP_WHATSAPP_MESSAGE)}`,
    },
    termsLinks: [
        { id: 'copyright', text: '2026 Betre all right reserved.' },
        { id: 'privacy', text: 'Privacy Policy' },
        { id: 'terms', text: 'Terms of Service' },
        { id: 'cookies', text: 'Cookies Settings' },
    ],
};
